var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResultsErrorDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 350 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h350v300h-350z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.60547 178v3",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.86719 179.625 2.45143 2.524",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 186.343h3.46629",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.58594 193.18 2.45143-2.524",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.60547 194v-3",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6055 192-2-2",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6055 187h-3",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6055 180-2 2",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.605 47v2",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.605 53h2",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.605 59v-2",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.605 53h-2",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.6055 131v3",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.6055 140h3",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.6055 148v-3",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.6055 140h-3",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.859 240.039c2.39 0 4.328 1.939 4.328 4.329 0 2.391-1.938 4.329-4.328 4.329s-4.328-1.938-4.328-4.329",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m289.666 200.763c2.57-.801 6.509-3.944 7.421-7.325.827 2.989 4.293 6.524 7.421 6.791-3.521 1.247-6.887 4.95-7.421 7.859-.364-2.965-5.019-6.892-7.421-7.325z",
    fill: "#1e2129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.877 238.705c1.2853-.4 3.254-1.971 3.7099-3.662.4134 1.494 2.1462 3.262 3.7099 3.396-1.7598.622-3.4425 2.474-3.7099 3.929-.1817-1.483-2.5095-3.447-3.7099-3.663z",
    fill: "#1e2129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.7294 99.597c0 1.855-1.5026 3.357-3.3559 3.357-1.8541 0-3.3559-1.502-3.3559-3.357 0-1.8537 1.5018-3.3568 3.3559-3.3568 1.8533 0 3.3559 1.5031 3.3559 3.3568z",
    fill: "#2d323d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.824 108.611c0 3.098-2.512 5.61-5.609 5.61-3.098 0-5.61-2.512-5.61-5.61 0-3.099 2.512-5.611 5.61-5.611 3.097 0 5.609 2.512 5.609 5.611z",
    fill: "#1e2129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.449 301.268c0 1.549-1.256 2.805-2.805 2.805s-2.804-1.256-2.804-2.805c0-1.55 1.255-2.806 2.804-2.806s2.805 1.256 2.805 2.806z",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.78 78.0316c0 1.8546-1.502 3.3568-3.356 3.3568-1.853 0-3.356-1.5022-3.356-3.3568 0-1.8537 1.503-3.3568 3.356-3.3568 1.854 0 3.356 1.5031 3.356 3.3568z",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.296 253.947h-82.174c-5.784 0-10.5185-4.719-10.5185-10.486v-116.459c0-5.767 4.7345-10.483 10.5185-10.483h82.174c5.786 0 10.52 4.716 10.52 10.483v116.459c0 5.767-4.734 10.486-10.52 10.486z",
    fill: "#11141a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.296 261.947h-82.1743c-5.7838 0-10.5182-4.719-10.5182-10.486v-116.459c0-5.767 4.7344-10.483 10.5182-10.483h82.1743c5.786 0 10.52 4.716 10.52 10.483v116.459c0 5.767-4.734 10.486-10.52 10.486z",
    fill: "#1e2129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.296 261.947h-82.1743c-5.7838 0-10.5182-4.719-10.5182-10.486v-116.459c0-5.767 4.7344-10.483 10.5182-10.483h82.1743c5.786 0 10.52 4.716 10.52 10.483v116.459c0 5.767-4.734 10.486-10.52 10.486z",
    fill: "#1e2129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.451 160h-60.695c-1.734 0-3.152-1.35-3.152-2.999 0-1.651 1.418-3.001 3.152-3.001h60.695c1.734 0 3.153 1.35 3.153 3.001 0 1.649-1.419 2.999-3.153 2.999z",
    fill: "#11141a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.451 178h-60.695c-1.734 0-3.152-1.35-3.152-2.999 0-1.651 1.418-3.001 3.152-3.001h60.695c1.734 0 3.153 1.35 3.153 3.001 0 1.649-1.419 2.999-3.153 2.999z",
    fill: "#11141a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.451 196h-60.695c-1.734 0-3.152-1.35-3.152-2.999s1.418-3.001 3.152-3.001h60.695c1.734 0 3.153 1.352 3.153 3.001s-1.419 2.999-3.153 2.999z",
    fill: "#11141a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.451 214h-60.695c-1.734 0-3.152-1.35-3.152-2.999 0-1.651 1.418-3.001 3.152-3.001h60.695c1.734 0 3.153 1.35 3.153 3.001 0 1.649-1.419 2.999-3.153 2.999z",
    fill: "#11141a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.438 232h-31.669c-1.741 0-3.165-1.35-3.165-2.999 0-1.651 1.424-3.001 3.165-3.001h31.669c1.741 0 3.166 1.35 3.166 3.001 0 1.649-1.425 2.999-3.166 2.999z",
    fill: "#11141a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.358 216.737c-12.136 12.134-30.925 13.503-44.566 4.135-1.743-1.219-3.403-2.588-4.95-4.135-.797-.794-1.547-1.613-2.255-2.476-1.415-1.723-2.654-3.56-3.67-5.458-1.789-3.206-3.005-6.608-3.669-10.124-2.143-11.028 1.061-22.898 9.594-31.427 8.554-8.555 20.426-11.738 31.455-9.616 3.515.685 6.92 1.901 10.126 3.669 1.901 1.038 3.713 2.278 5.439 3.692.86.705 1.68 1.458 2.474 2.255 1.549 1.547 2.939 3.203 4.135 4.949 9.373 13.636 8.001 32.424-4.113 44.536z",
    fill: "#0d0e0f",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.962 214.347c-12.626 12.629-33.089 12.626-45.718 0-12.612-12.613-12.612-33.077.017-45.704 12.612-12.613 33.075-12.613 45.687 0 12.627 12.627 12.627 33.091.014 45.704zm6.48-52.191c-16.207-16.208-42.47-16.208-58.678 0-16.205 16.205-16.219 42.484-.014 58.692 14.751 14.746 37.871 16.076 54.132 3.968 1.588-1.184 3.118-2.511 4.577-3.968 1.457-1.459 2.784-2.989 3.966-4.577 12.107-16.264 10.766-39.367-3.983-54.115z",
    fill: "#505666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.072 215.045 12.571 11.988-8.51 8.922-12.568-11.988c1.591-1.246 3.117-2.637 4.572-4.159 1.451-1.521 2.768-3.114 3.935-4.763z",
    fill: "#6d7587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.548 261.054-.494.494c-3.267 3.269-8.617 3.269-11.886 0l-30.168-30.168 12.38-12.38 30.168 30.168c3.269 3.269 3.269 8.617 0 11.886z",
    fill: "#d13e3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249 249.138-11.864 11.862-2.136-2.138 11.862-11.862z",
    fill: "#f4625f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220 219.811-12.189 12.189-1.811-1.811 12.189-12.189z",
    fill: "#f68582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.604 164.299-42.704 42.701c-1.608-2.882-2.702-5.941-3.296-9.102l36.897-36.898c3.159.618 6.22 1.709 9.103 3.299z",
    fill: "#0d0e0f",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.604 174.448-46.168 43.552c-1.653-1.088-3.227-2.313-4.694-3.698-.755-.712-1.47-1.443-2.138-2.215l46.729-44.087c.818.633 1.595 1.307 2.348 2.02 1.468 1.384 2.788 2.866 3.923 4.428z",
    fill: "#0d0e0f",
    fillOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsErrorDark);
export default __webpack_public_path__ + "static/media/NoResultsErrorDark.5459d76e7da48cf1b1a8167c1460f028.svg";
export { ForwardRef as ReactComponent };